module.exports = __webpack_public_path__ + "img/screen1.186e8d40.jpg";